"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledDialogTitle = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledDialogTitle = styled_components_1.default.div `
  display: flex;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing(3)};
  align-items: flex-start;

  .title-text {
    word-break: break-all;
  }
`;
